import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekDivider = styled(Divider)(({ theme }) => ({
    borderColor: theme.palette.grey[500],
    "&.MuiDivider-light": {
        borderColor: theme.palette.grey[100],
    },
}));

export { PeekDivider, PeekDivider as default };
